import React from "react";
import SideBar from "../../../SideBar";

const QuicksightAnalytics = () => {
  return (
    <div style={({ height: "100vh" }, { display: "flex" })}>
      <SideBar></SideBar>
      <div className="container-fluid p-0 overflow-x-none">
        <div className="row">
          <main className="scrollable-container col-lg-10">
            <iframe
              title="QuickSight Analytics"
              style={{ width: '100%', height: '80vh' }}
              src="https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/049674162985/dashboards/74dcd017-c894-463a-b428-1b91f212d17e?directory_alias=cm-dashboard">
            </iframe>
          </main>
        </div>
      </div>
    </div>
  );
};

export default QuicksightAnalytics;
